import { Injectable } from '@angular/core';
import { BaseApiService } from '../../common/base-api.service';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { SettingsProviderService } from '../../common/settings-provider.service';
import { ICompanyDocument } from '../../message-models/company-document.interface';
import { Observable, of } from 'rxjs';
import { DocumentEntityType } from '../../message-models/document-entity-type.enum';
import { ICompanyDocumentSummary } from '../../message-models/company-document-summary.interface';
import { IDocumentSummaryInfo } from '../../message-models/document-summary-info.interface';

@Injectable({
  providedIn: 'root'
})

export class CompanyDocumentService extends BaseApiService {

  constructor(http: HttpClient) {
    super(http, new SettingsProviderService('ecaApi'), 'CompanyDocument');
  }

  getAllDocumentSummariesByEntityType(companyId: string, entityType?: DocumentEntityType, includeExpired?: boolean): Observable<IDocumentSummaryInfo[]> {
    return this.post<IDocumentSummaryInfo[]>('getAllDocumentSummariesByEntityType', { companyId, entityType, includeExpired });
  }

  getAllDocumentSummariesForEnterprise(companyId: string, includeExpired?: boolean): Observable<IDocumentSummaryInfo[]> {
    return this.post<IDocumentSummaryInfo[]>('getAllDocumentSummariesForEnterprise', { companyId, includeExpired });
  }

  getAllDocumentSummariesForOperatives(companyId: string, includeExpired?: boolean): Observable<IDocumentSummaryInfo[]> {
    return this.post<IDocumentSummaryInfo[]>('getAllDocumentSummariesForOperatives', { companyId, includeExpired });
  }

  getCompanyDocument(documentId: string): Observable<ICompanyDocument> {
    return this.post<ICompanyDocument>('GetCompanyDocument', { documentId });
  }
  getCompanyDocumentSummary(documentId: string): Observable<ICompanyDocumentSummary> {
    return this.post<ICompanyDocumentSummary>('GetCompanyDocumentSummary', { documentId });
  }
  getCompanyDocumentForViewOrDownload(documentId: string): Observable<HttpEvent<Blob>> {
    return this.http.request(new HttpRequest(
      'POST',
      this.baseUrl + 'GetCompanyDocumentForViewOrDownload',
      { documentId },
      {
        reportProgress: true,
        responseType: 'blob'
      }));
  }
  createOrUpdateCompanyDocument(companyDocumentUpload: any): Observable<ICompanyDocumentSummary> {
    return this.post<ICompanyDocumentSummary>('CreateOrUpdateCompanyDocument', companyDocumentUpload);
  }

  deleteCompanyDocument(documentId: string, companyId: string): Observable<ICompanyDocument> {
    return this.post<ICompanyDocument>('DeleteCompanyDocument', { companyId, documentId });
  }
}
